import { TParsedGuidanceArticle, TZendeskGuidanceArticle } from './types'

const normalizeTitle = (value: string | null) =>
  (value ?? '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

const serializeNode = (node: ChildNode) => {
  const container = document.createElement('div')
  container.appendChild(node.cloneNode(true))
  return container.innerHTML
}

const findNextContentNode = (nodes: ChildNode[], currentIndex: number) => {
  for (let index = currentIndex + 1; index < nodes.length; index += 1) {
    const node = nodes[index]
    if (node.nodeType !== Node.TEXT_NODE || node.textContent?.trim()) {
      return { index, node }
    }
  }

  return undefined
}

export const parseZendeskArticle = (
  article: TZendeskGuidanceArticle,
): TParsedGuidanceArticle => {
  const document = new DOMParser().parseFromString(
    article.bodyHtml,
    'text/html',
  )
  const nodes = Array.from(document.body.childNodes)
  const introHtml: string[] = []
  const accordions: TParsedGuidanceArticle['accordions'] = []

  for (let index = 0; index < nodes.length; index += 1) {
    const node = nodes[index]
    const isAccordionHeading =
      node instanceof HTMLElement &&
      node.matches('h3.accordion') &&
      normalizeTitle(node.textContent)

    if (isAccordionHeading) {
      const nextContent = findNextContentNode(nodes, index)

      if (
        nextContent?.node instanceof HTMLElement &&
        nextContent.node.matches('div.accordion-panel')
      ) {
        accordions.push({
          id: node.id || `${article.id}-section-${accordions.length + 1}`,
          title: normalizeTitle(node.textContent),
          panelHtml: nextContent.node.innerHTML,
        })
        index = nextContent.index
        continue
      }
    }

    introHtml.push(serializeNode(node))
  }

  return {
    ...article,
    introHtml: introHtml.join(''),
    accordions,
  }
}
